import React from "react";
import "./subletting.css";
import SEOTags from "../../utils/SEOTags";
import Layout from "../../components/layout/Layout";
import RoundedLinkButton from "../../components/Buttons/RoundedLinkButton/RoundedLinkButton";

const BreadcrumbListSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      item: { "@id": "https://www.vakansa.se/", name: "Hem" },
    },
    {
      "@type": "ListItem",
      position: 2,
      item: {
        "@id": `https://www.vakansa.se/andrahandsuthyrning`,
        name: "Andrahandsuthyrning",
      },
    },
  ],
};

export default function Subletting() {
  return (
    <div className="subletting-outer">
      <SEOTags
        title={"Hyr ut lokal i andrahand med Vakansa"}
        description={
          "Har du en ledig lokal eller en yta i en lokal som du vill hyra ut i andrahand? Välkommen då till Sveriges främsta andrahandsplattform för lokaler."
        }
        canonicalUrl={"/andrahandsuthyrning"}
        ogImage={"/images/logo/meta-logo.jpg"}
        structuredData={BreadcrumbListSchema}
      />
      <div className="subletting-inner">
        <Layout>
          <main className={`subletting-container`}>
            <div className={`subletting-intro-content`}>
              <div className={`subletting-intro-text`}>
                <h1>Hyra ut lokal i andrahand</h1>
                <h2>Att tänka på kring andrahandsuthyrning av lokaler</h2>
                <br />
                <h3>Uthyrning av lokal i andra hand</h3>
                <p>
                  Har du funderat på att hyra ut din lokal, men vet inte var du
                  ska börja och hur hela processen går till? Kanske du
                  fortfarande är lite skeptisk till att hyra ut en lokal i andra
                  hand, men vill gärna höra hur det går till? Då kan den här
                  guiden hjälpa dig med att komma igång med att hyra ut lokal i
                  andra hand! Vi på Vakansa vill gärna att allt fler börjar hyra
                  ut och hyra lokaler i andra hand, för att spara på
                  kostnaderna, men även för att minska behovet av att bygga
                  nytt. Guiden kommer att gå igenom hur du bestämmer vilket
                  utrymme att hyra ut, hur du skapar en annons för att hitta din
                  framtida hyresgäst.
                </p>
                <br />
                <h4>1. Identifiera yta att hyra ut</h4>
                <p>
                  Det första är att identifiera vilket utrymme som ska hyras ut.
                  Det finns flera sätt att hyra ut en lokal. Antigen hyr man ut
                  ett rum som alltid står tomt, i så fall kan man hyra ut
                  lokalen för längre tid, månadsvis. Kanske kontoret står tomt 2
                  dagar i veckan, då kan man hyra ut lokal per dag istället. Om
                  det är ett mötesrum som står tomt stora delar av dagen, då kan
                  man hyra ut den när rummet är vakant. Oavsett vilken lokal det
                  gäller om, är det viktigt att utrymmet hyrs ut för liknande
                  ändamål, så att en kontorslokal inte hyrs ut som en eventlokal
                  för fester. Det är viktigt även att veta vad som ska ingå i
                  hyran, ska till exempel Wi-Fi och kök ingå eller inte? Om du
                  inte är säker på allt som behöver nämnas,{" "}
                  <a href="/registrera-konto">registrera ett konto</a> och börja
                  skapa en annons för att ta reda på vilken viktig information
                  behövs.
                </p>
                <h4>2. Skapa lokalannons</h4>
                <p>
                  När du har registrerat ett konto hos Vakansa och har ett
                  utrymme redo att hyras ut är det dags för att skapa en annons.
                  En bra inställning att ha när man skapar en annons är att
                  tänka att annonsen ska ge tillräckligt mycket information för
                  potentiella hyresgäster att de ska bli intresserade. Se till
                  att använda den bästa bilden först, då den kommer att synas
                  först och för alla som letar bland lediga lokaler. På
                  beskrivningen, skriv gärna vilka olika ändamål lokalen kan
                  användas till och inte användas till, för att göra det enklare
                  för hyresgästen att hitta en lokal för deras ändamål. Markera
                  vad som ingår i uthyrningen av lokalen. För att få idéer,
                  kolla gärna hur andra har skapat sina annonser på{" "}
                  <a href="/lediga-lokaler">lediga lokaler-sidan.</a>
                </p>
                <h4>3. Hitta hyresgäst till lokal</h4>
                <p>
                  När annonsen är uppe och är klar kan potentiella hyresgäster
                  börja se annonsen för lokalen. På Vakansa syns de senaste
                  annonserna först och högst upp, för att gynna nya annonser.
                  Vid annonsen på mina sidor kan du även se hur många visningar
                  din annons har fått. Även om din annons inte är den nyaste,
                  går det fortfarande att hitta den, bland andra lediga lokaler
                  och finnas tillgänglig för potentiella hyresgäster. Det kostar
                  ingenting att ha sin annons uppe på Vakansa, så oroa dig inte
                  över om annonsen sitter uppe ett längre tag.
                </p>
                <h4>4. Hyr ut lokal</h4>
                <p>
                  När intresserade hyresgäster skickar intresseanmälningar
                  kommer du att få dem via mail. Se till att vara snabb på
                  bollen för att svara på mailet, då är det upp till dig att
                  stämma av en visning eller att gå vidare med
                  uthyrningsprocessen. Oavsett om ni stämmer av en visning eller
                  inte, är det viktigt att rapportera till Vakansa hur processen
                  går/gick med varje intresseanmälan. Om visningen gick bra och
                  ni kom överens om ett avtal, är det viktigt att upprätthålla
                  ett formellt andrahandskontrakt för allt ni kommit överens om
                  på papper. Vid en lyckad förmedling tar vi på Vakansa 15% av
                  hyresintäkterna som förmedlingsavgift per månad, upp till max
                  12 månaders hyra.{" "}
                  <a href="/hyr-ut-lokal">
                    Klicka här för att läsa mer om Vakansas prismodell.
                  </a>
                </p>
                <h3>Gör uthyrningen enklare med Vakansa Mest</h3>
                <p>
                  Vill du göra uthyrningsprocessen enklare? Prova vårt paket{" "}
                  <a href="/blogg/hyr-ut-din-lokal-med-vakansa-mest">
                    Vakansa Mest
                  </a>{" "}
                  som är gjord för att göra det så enkelt som möjligt för
                  företag och organisationer att hyra ut lokal, framförallt för
                  er som har ingen erfarenhet av lokaluthyrning. Med Vakansa
                  Mest kan du få hjälp med flera kringtjänster kopplade till
                  lokaluthyrningen.
                </p>
                <p>Tjänster som Vakansa Mest erbjuder:</p>
                <ul>
                  <li>Hjälp med avtal</li>
                  <li>Hjälp med momsregler</li>
                  <li>Hjälp med digitalt bokningssystem</li>
                  <li>Hjälp med nyckelhantering</li>
                  <li>Hjälp med försäkring</li>
                </ul>
                <br />
                <h3>Frågor om att vara hyresvärd</h3>
                <p>
                  Om du har fler frågor, kolla om du kan hitta svaret till
                  frågan på vår{" "}
                  <a href="/fragor-och-svar/hyresvard">frågor och svar sida.</a>{" "}
                  Om du inte hittar svaren där, gå igenom{" "}
                  <a href="/anvandarvillkor">användarvillkoren.</a> Vi på
                  Vakansa vill att fler ska börja hyra ut sin lokal, så kontakta
                  oss på mail, så svarar vi gärna på dina frågor för att komma
                  igång med lokaluthyrning på Vakansa.
                </p>
                <br />
                <p>
                  Behöver du hjälp med att se över eller skriva ett
                  andrahandskontrakt?
                </p>
                {/* <b>
                  Hör av er till oss <a href="/kontakta-oss">här</a>
                </b> */}
                <RoundedLinkButton 
                  href={"/kontakta-oss"}
                  color="green"
                  size="md"
                  label={"Kontakta oss här"}/>
              </div>{" "}
            </div>
          </main>{" "}
        </Layout>
      </div>
    </div>
  );
}
